import { useSelector } from "react-redux"
import { oauthErrorIcon } from "../../utility-functions/assetLoader"
import Button from "../design/Button"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { JService } from "../api-service/ApiService"
import { enqueueSnackbar } from 'notistack'
import classes from './AccountSuspended.module.css'
import { isSuspended } from "../../utility-functions"

const AccountSuspended = () => {
    const reduxSubscription = useSelector(state=>state?.account?.value?.subscription);
    const {canManageBillingSubscription} = useSelector((state) => state?.auth?.permissions);

    const navigate=useNavigate()

    const [loading, setLoading]=useState(false)

    useEffect(()=>{
        if(!isSuspended(reduxSubscription?.status)) {
            navigate('/activity-logs/calls',{replace:true})
        }
    }, [reduxSubscription])

    const handlePayInvoice=()=>{
        if(isSuspended(reduxSubscription?.status) && reduxSubscription?.payment_due_date === null){
            navigate("/upgrade");
            return;
        }
        setLoading(true)
        JService.get('/api/v1/subscriptions/pay-now/')
        .then((res)=>{
            if(!res?.success){
                throw new Error(res?.message || 'Something went wrong')
            }
            if(res?.url){
                window.location.href=res.url
            }
        })
        .catch((err)=>{
			enqueueSnackbar(err?.message, { variant: "error"})
        })
        .finally(()=>{
            setLoading(false)
        })
    }

    const isOverdue = reduxSubscription?.payment_due_date ? (Date.now() - new Date(reduxSubscription?.payment_due_date)) >= 0 : false;

    const getSuspensionReason = () => {
        if (!canManageBillingSubscription) return `Your FreJun account is under review. Please contact your account admin.`;
        if (reduxSubscription?.status === "SUSPENDED_UCC") return "Your account has been suspended due to UCC compliance issues.";
        if (reduxSubscription?.status === "SUSPENDED_DOCS") return "Your account has been suspended due to pending documentation.";
        if (reduxSubscription?.status === "PAUSED") return "Your account has been paused.";
        if (reduxSubscription?.payment_due_date) return "To restore, please pay the unpaid invoice.";
        return "To restore, please upgrade your account";
    };

    return (
      <div className={`screen-container ${classes.container}`}>
        <div className={classes.infoContainer}>
          <span>{oauthErrorIcon("#e0544c", 54, 54)}</span>
          <p className="t6 medium-font">
            {canManageBillingSubscription
              ? "Account suspended"
              : "Account under review"}
          </p>
          <p className={`t7 regular-font ${classes.info}`}>
            {getSuspensionReason()}
            <br />
            {canManageBillingSubscription &&
              "Contact chat support for assistance."}
          </p>
          {canManageBillingSubscription &&
            (isOverdue || !reduxSubscription?.payment_due_date) && (
              <Button
                buttonText={
                  reduxSubscription?.payment_due_date
                    ? "Pay invoice"
                    : "Upgrade"
                }
                onClick={handlePayInvoice}
                hierarchy="white"
                variant="outlined"
                disabled={false}
                isLoading={loading}
              />
            )}
        </div>
      </div>
    );
}
  
export default AccountSuspended